var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:transparent;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    d: "M11.1,6.9C11,8.1,10.4,9.2,9.5,10c-1.9,1.6-4.8,1.4-6.4-0.5S1.7,4.7,3.6,3c1.9-1.6,4.6-1.4,6.3,0.4L8.5,3.3 L8.4,4.2l3,0.3l0.3-3l-0.9-0.1l-0.1,1.4c-2-2.2-5.5-2.4-7.7-0.4c-2.2,2-2.4,5.5-0.4,7.7c2,2.2,5.3,2.4,7.6,0.5 c1.1-0.9,1.8-2.3,1.9-3.7L11.1,6.9z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkdydXBwZV8yNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDEzIDEzIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMyAxMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOnRyYW5zcGFyZW50O30KPC9zdHlsZT4KPGc+Cgk8cmVjdCBjbGFzcz0ic3QwIiB3aWR0aD0iMTMiIGhlaWdodD0iMTMiLz4KCTxwYXRoIGlkPSJQZmFkXzE2IiBkPSJNMTEuMSw2LjlDMTEsOC4xLDEwLjQsOS4yLDkuNSwxMGMtMS45LDEuNi00LjgsMS40LTYuNC0wLjVTMS43LDQuNywzLjYsM2MxLjktMS42LDQuNi0xLjQsNi4zLDAuNEw4LjUsMy4zCgkJTDguNCw0LjJsMywwLjNsMC4zLTNsLTAuOS0wLjFsLTAuMSwxLjRjLTItMi4yLTUuNS0yLjQtNy43LTAuNGMtMi4yLDItMi40LDUuNS0wLjQsNy43YzIsMi4yLDUuMywyLjQsNy42LDAuNQoJCWMxLjEtMC45LDEuOC0yLjMsMS45LTMuN0wxMS4xLDYuOXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };